// ----------------------------------------------------------------------
// <copyright file="Izenda.UserItemAction.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var compose = require('recompose').compose;
  var withProps = require('recompose').withProps;
  var withHandlers = require('recompose').withHandlers;
  var setPropTypes = require('recompose').setPropTypes;
  var PropTypes = require('react').PropTypes;
  var connect = require('share/enhancers/Izenda.Connect');
  var constants = require('logic/data/Izenda.UserAccountConstants');
  var observer = require('mobx-react').observer;
  var commonMessage = require('share/messages/Izenda.CommonMessages');
  const { curry, isNil, isEmpty } = require('lodash/fp');

  var userItemAction = compose(
    setPropTypes({
      userInfo: PropTypes.object.isRequired,
      store: PropTypes.object.isRequired
    }),
    connect(),
    withHandlers({
      onToggleActive: curry(onToggleActive),
      onDelete: curry(onDelete),
      onSelectUser: curry(onSelectUser)
    })
  );

  /**
   * [on Toggle Active user set up
   * @param  {object} props
   * @param  {object} e
   */
  function onToggleActive(props, e) {
    var loader = props.loader;
    var store = props.store;
    var userInfo = props.userInfo;
    var handleSetUserStatus = function(activate) {
      loader.startLoading();
      store
        .setUserStatus(userInfo, activate)
        .then(showErrorPopup.bind(null, props))
        .finally(loader.endLoading.bind(loader));
    };

    if (userInfo.active) {
      props
        .confirmFn('Confirmation', {
          description: constants.MESSAGE.DEACTIVE
        })
        .then(function() {
          handleSetUserStatus(false);
        });
    } else {
      handleSetUserStatus(true);
    }
  }

  /**
   * [onDelete user detail
   * @param  {object} props
   * @param  {object} e
   */
  function onDelete(props, e) {
    e.preventDefault();
    e.stopPropagation();

    var loader = props.loader;
    var store = props.store;
    var handleDelete = function() {
      return props
        .confirmFn('Confirmation', {
          description: constants.MESSAGE.DELETE
        })
        .then(function() {
          loader.startLoading();
          store
            .deleteUser(props.userInfo)
            .then(showErrorPopup.bind(null, props))
            .finally(loader.endLoading.bind(loader));
        });
    };
    if (props.userInfo.systemAdmin) {
      store.checkLastSystemAdmin().then(function(result) {
        if (result.data) {
          return props.confirmMessage('error', constants.MESSAGE.LAST_SYSTEM_ADMIN);
        } else {
          handleDelete();
        }
      });
    } else {
      handleDelete();
    }
  }

  /**
   * show Error Popup
   * @param  {object} props
   * @param  {object} result
   */
  function showErrorPopup(props, result) {
    if (!isNil(result.messages) && !isEmpty(result.messages[0])) {
      return props.confirmMessage('error', result.messages[0].messages[0]);
    }
  }

  /**
   * on Select User
   * @param  {object} props
   * @param  {object} e
   */
  function onSelectUser(props, e) {
    var loader = props.loader;
    var store = props.store;
    var valManager = props.validation;

    valManager.reset();
    props
      .confirmDirtyForm(store.isDirty)
      .then(store.selectUser.bind(store, props.userInfo))
      .finally(loader.endLoading.bind(loader));
  }

  module.exports = userItemAction;
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/UserSetup/MiddlePanel/Izenda.UserItemAction.js